import { UIIcon } from '../../config/icons';
import { c_cities } from '../mdl/c-city';
import { the_links } from '../mdl/f-links';
import { FPageButtonsBlock, FPageFAQBlock, FPageHubspotBlock, FPageAppRatingBlock, FPageHLineBlock, FPageBannerBlock, FPageImagesBlock, FPageInfoBlock, FPageCardsBlock, FPageNewsletterBlock, FPageTableBlock, FPageTestimonialBlock, FPageTextBlock, FPageBubbleBlock } from '../mdl/f-page-block';
import { subscribeNewsletter } from '../mdl/m-newsletter';
import { getCountry } from '../me/me';
import { onAttach } from '../ui/attach';
import { UIButton } from '../ui/component/button';
import { UITextInput } from '../ui/component/input';
import { UIAutofill } from '../ui/component/input-base';
import { hLine } from '../ui/component/line';
import { UIMediaBranch } from '../ui/component/mediabranch';
import { UISelect } from '../ui/component/select';
import { UISnapCarousel } from '../ui/component/snapcarousel';
import { $el } from '../ui/elements';
import { uiParseLinkString } from '../ui/util';
import { UIViewSpec } from '../ui/view';
import { $form } from '../y/form';
import { $i18n } from '../y/i18n';
import { loadHubspot, makeImage, makeCoverImage, makeStar } from './elements';
import { blkRegister } from './registry';
import { makePageBlock } from './render';

blkRegister<FPageButtonsBlock>('buttons', (b, _s, _p, _id, _flags) => {
    return $el.DIV(['l-button-row b b-content w-block-1200', b.column && 'm-column', 'm-' + (b.align ?? 'left')], b.buttons.map(bb => {
        const button = new UIButton({ title: $el.fromEditedHtml(bb.text, undefined, 'span'), left_icon: bb.icon, classes: 'ui-tint-black', link: uiParseLinkString(bb.link), kind: 'k-shadow' });
        return button;
    }));
});

blkRegister<FPageFAQBlock>('faq', (b, _s, _p, _id, _flags) => {
    return $el.DIV(['w-block-1200 b b-content'], b.groups.map(g => $el.DIV(['o-faq-group', !b.headers && 'm-no-header'], [
        b.headers && $el.fromEditedHtml(g.title, 'r-title'),
        g.items.map(i => {
            const arrow = $el.DIV('r-arrow');
            arrow.innerHTML = '<svg class="r-left" viewBox="0 0 96 96"><rect width="26" height="7" x="25.5" y="44.5"/></svg>' +
                '<svg class="r-right" viewBox="0 0 96 96"><rect width="26" height="7" x="44.5" y="44.5"/></svg>';

            const q = $el.DIV('r-q', [$el.fromEditedHtml(i.q, 'r-text'), !b.expanded && arrow]);
            const a = $el.DIV('r-a', $el.fromEditedHtml(i.a, 'r-box'));

            if(!b.expanded) {
                a.ui_hide();
                let open = false;

                q.addEventListener('click', () => {
                    open = !open;
                    a.ui_show('slide-v', open);
                    arrow.classList.toggle('f-up', open);
                });
            }

            return $el.DIV('o-faq-item', [q, a]);
        })
    ])));
});

blkRegister<FPageHubspotBlock>('hubspot', b => {
    const block = $el.DIV('blk-hubspot');
    const id = $el.newId();
    block.id = id;

    loadHubspot().then(() => {
        (window as any).hbspt.forms.create({
            region: b.region,
            portalId: b.portal_id,
            formId: b.form_id,
            target: '#' + id
        });
    });

    return block;
});

blkRegister<FPageAppRatingBlock>('app_rating', b => {
    const block = $el.DIV('blk-apprating b', [
        $el.A(the_links.reviews_apple, [
            $el.ICON(UIIcon.BRAND_APPLE),
            $el.DIV('r-text', '4.7'),
            $el.DIV('r-stars', [makeStar(), makeStar(), makeStar(), makeStar(), makeStar(true)])
        ], 'r-rating'),
        $el.A(the_links.reviews_google, [
            $el.ICON(UIIcon.BRAND_GOOGLE),
            $el.DIV('r-text', '4.7'),
            $el.DIV('r-stars', [makeStar(), makeStar(), makeStar(), makeStar(), makeStar(true)])
        ], 'r-rating'),
    ]);

    if(b.split)
        block.classList.add('m-split');

    return block;
});

blkRegister<FPageHLineBlock>('hline', () => {
    const block = hLine();
    return block;
});

blkRegister<FPageBannerBlock>('banner', b => {
    const banner1 = $el.DIV('r-banner');
    const banner2 = $el.DIV('r-banner');
    for(const i of b.images) {
        banner1.ui_add(makeImage(i, true, undefined, 1.2));
        banner2.ui_add(makeImage(i, true, undefined, 1.2));
    }
    banner1.ui_add($el.DIV('r-bubble', [$el.DIV('sym sym-' + b.symbol), $el.fromEditedHtml(b.text, 'o-bubble m-shadow m-top-arrow p-f-new-bubble')]));
    banner2.ui_add($el.DIV('r-bubble', [$el.DIV('sym sym-' + b.symbol), $el.fromEditedHtml(b.text, 'o-bubble m-shadow m-top-arrow p-f-new-bubble')]));

    return $el.DIV(['blk-banner', b.multiply && 'm-multiply'], [banner1, banner2]);
});

blkRegister<FPageImagesBlock>('images', b => {
    return $el.DIV(['blk-images b b-content', 'k-' + b.layout, b.multiply && 'm-multiply', b.mobile_scale && 'm-mobile-scale', b.narrow ? 'w-block-1200' : 'w-block'], b.images.map(i => makeImage(i, b.layout == 'big')));
});

blkRegister<FPageInfoBlock>('info', (b, _s, _p, _id, _flags) => {
    if(b.kind == 'genres') {
        const cards = b.items.map((i, n) => {
            const item = $el.DIV('o-info-genre', [
                makeCoverImage(i.image!, 'r-image'),
                $el.fromEditedHtml(i.text, 'r-text')
            ]);
            if(n == 3 || n == 10)
                item.classList.add('m-crop-top');
            else if(n == 6 || n == 13)
                item.classList.add('m-crop-bottom');
            return item;
        });
        return $el.DIV('blk-info-genres w-block b b-content', [
            $el.DIV('r-column', cards.slice(0, 3)),
            $el.DIV('r-column', cards.slice(3, 7)),
            $el.DIV('r-column', cards.slice(7, 10)),
            $el.DIV('r-column', cards.slice(10, 14)),
        ]);
    } else {
        return $el.DIV(['blk-info w-block b b-content', 'k-' + (b.kind ?? 'legacy')], b.items.map(i => {
            return $el.DIV(['o-info-item', i.extend && 'm-extend', i.flip && 'm-flip'], [
                i.image && makeImage(i.image, true, 'r-image'),
                $el.fromEditedHtml(i.text, 'r-text')
            ])
        }));
    }
});

blkRegister<FPageCardsBlock>('cards', b => {
    const cards = b.items.map(i => {
        return $el.DIV('o-card m-soft-shadow m-activable', [
            i.symbol && $el.DIV('r-symbol m-40', $el.DIV('sym sym-' + i.symbol)),
            $el.fromEditedHtml(i.title, 'r-title'),
            hLine(),
            $el.fromEditedHtml(i.text, 'r-text')
        ])
    });

    return new UIMediaBranch('m', () => {
        const m_cards: UIViewSpec[] = cards.map(c => c.cloneNode(true));
        // while(m_cards.length < 5) {
        //     m_cards.push(...cards.map(c => c.cloneNode(true)));
        // }

        const carousel = new UISnapCarousel(m_cards, { classes: 'blk-cards b b-content', card_width: 180, gap: 18 });
        return carousel;
    }, () => {
        const d_cards = cards.map(c => c.cloneNode(true));
        const block = $el.DIV('blk-cards w-block b b-content', d_cards);

        if(d_cards.length > 1) {
            d_cards[0].classList.add('f-active');
            let current = 0;
            let refreshing = false;

            onAttach(block, () => {
                if(refreshing) return;

                const handle = setInterval(() => {
                    if(!block.isConnected) {
                        clearInterval(handle);
                        refreshing = false;
                        return;
                    }

                    d_cards[current].classList.remove('f-active');
                    current = (current + 1) % cards.length;
                    d_cards[current].classList.add('f-active');
                }, 2000);

                refreshing = true;
            });
        }

        return block;
    });
});

blkRegister<FPageNewsletterBlock>('newsletter', (_b, _s, _p, _id, _flags) => {
    const country = getCountry();
    const city_values = c_cities.all.filter(c => c.country == country).map(c => ({ key: c.id, name: c.name })).sort((a, b) => a.name.localeCompare(b.name));

    const email = new UITextInput({ type: 'email', placeholder: $i18n.tl.ph_email, autofill: UIAutofill.EMAIL, required: true });
    const city = new UISelect(city_values, { required: true, placeholder: $i18n.tl.ph_city });

    const form = $form({ _: [email, city] });

    const register = new UIButton({
        title: $i18n.tl.b_send, kind: 'k-shadow', classes: 'ui-tint-blue', on_click: () => {
            if(!form.validate()) return;

            const city_id = city.value;
            const city_name = city_values.find(v => v.key == city_id)!.name;

            return subscribeNewsletter(email.value, `news-${city_id}`).then(() => {
                block.ui_empty($el.B($i18n.tl.t_newsletter_thanks_city + ' ' + city_name));
            });
        }
    });

    const block = $el.DIV('blk-newsletter', [email, city, register]);
    return block;
});

blkRegister<FPageTableBlock>('table', b => {
    return $el.DIV(['w-hug b b-content blk-table'], $el.create('table', 'blk-table-table', [
        $el.create('thead', undefined, $el.create('tr', 'blk-table-tr', b.header.map(c => $el.fromEditedHtml(c, 'blk-table-th', 'th')))),
        $el.create('tbody', undefined, b.rows.map(r => $el.create('tr', 'blk-table-tr', r.map(c => $el.fromEditedHtml(c, 'blk-table-td', 'td')))))
    ]));
});

blkRegister<FPageTestimonialBlock>('testimonial', (b, _s, _p, _id, _flags) => {
    return $el.DIV(['blk-testimonial b b-content'], b.items.map(i => $el.DIV('o-bubble', [
        $el.fromEditedHtml(i.header, 'r-text'),
        $el.fromEditedHtml(i.text, 'r-signature'),
    ])))
});

blkRegister<FPageTextBlock>('text', b => $el.fromEditedHtml(b.text, ['w-block b b-block', b.columns && 'u-columns', b.narrow && 'w-narrow', b.hug && 'w-hug']));

blkRegister<FPageBubbleBlock>('bubble', (b, section, promises, id, page_flags) => {
    return $el.DIV(['blk-bubble b b-content', 'k-' + b.kind, 'm-align-' + b.align], [
        b.symbol && $el.DIV('sym sym-' + b.symbol),
        $el.DIV('o-bubble m-shadow m-top-arrow', b.blocks.map(bb => makePageBlock(bb, section, promises, id, page_flags)))
    ]);
});